/**
 * The service for modals.
 * Contains all the methods needed for managing modals.
 */
export class ModalService {
    /*@ngInject*/
    constructor($uibModalStack, $timeout) {
        this.$uibModalStack = $uibModalStack;
        this.$timeout = $timeout;
    }
    isAnyModalOpen() {
        return this.$uibModalStack.getTop();
    }
    addModalOpenClassToBodyIfAnyModalIsOpen() {
        if (this.isAnyModalOpen()) {
            // add back modal-open class to body to enable scrolling of the modal
            this.$timeout(() => {
                $('body').addClass('modal-open');
            }, 500);
        }
    }
    closeAllOpenModals() {
        this.$uibModalStack.dismissAll();
    }
}
//# sourceMappingURL=modalService.js.map